import React from "react";
import styles from "../stylesER.module.scss";

export const InteresesModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        style={{ maxWidth: "500px", width: "95%" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Detalle de Intereses</h3>
        <table className={styles.modalTable} style={{ marginBottom: "20px" }}>
          <thead>
            <tr>
              <th style={{ width: "60%", textAlign: "left" }}>Concepto</th>
              <th style={{ width: "40%", textAlign: "right" }}>Monto (USD)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "500" }}>Connolly</td>
              <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>US$ 1.676</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "500" }}>Otegui</td>
              <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>US$ 212</td>
            </tr>
            <tr style={{ fontWeight: "bold", borderTop: "2px solid #333" }}>
              <td style={{ textAlign: "left" }}>Total</td>
              <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>US$ 1.888</td>
            </tr>
          </tbody>
        </table>
        <div className={styles.modalActions}>
          <button className={styles.btnCancel} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
